import { Modal, Text, TextContainer } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { useBankControllerContext } from "../../pages/banking/hooks/bank-controller-context";

import { MESSAGES } from "./message-definitions";

interface RequireBankConnectionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RequireBankConnectionModal = ({ isOpen, onClose }: RequireBankConnectionModalProps) => {
  const intl = useIntl();
  const { requireConnection } = useBankControllerContext();

  return (
    <Modal
      title={intl.formatMessage(requireConnection ? MESSAGES.requireConnectionModalTitle : MESSAGES.requiredModalTitle)}
      isOpen={isOpen}
      onClose={onClose}
      primaryAction={{
        content: intl.formatMessage(MESSAGES.connectBankButton),
        onAction: onClose,
      }}
    >
      <TextContainer>
        <Text>
          {intl.formatMessage(requireConnection ? MESSAGES.requireConnectionModalBody : MESSAGES.requiredModalBody)}
        </Text>
      </TextContainer>
    </Modal>
  );
};
